module.exports = __webpack_public_path__ + "static/about-us-founder-photo-9e491d1d39446d400253e1b468a61805.jpg";